// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__25H1N","row":"Node_row__2Ld52","label":"Node_label__3Lx6h","footer":"Node_footer__3x1IZ"};